import OverviewMapBuildings from './OverviewMapBuildings';

export default OverviewMapBuildings;
